import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import clsx from "clsx"
import { Chip, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { updateFileTag } from "../../actions/documentsActions"
import RemoveTagSVG from "../icons/RemoveTagSVG"
import TagMenuSVG from "../icons/TagMenuSVG"
import TagMenuPoper from "./TagMenuPoper"
import { LIST_VIEW, LOCAL_STORAGE_KEYS } from "../../utils"

const useStyles = makeStyles((theme) => ({
	chipStyle: {
		...theme.typography.body1,
		display: "flex",
		alignItems: "center",
		fontSize: theme.typography.fontSize,
		gap: 4,
		borderRadius: 3,
		"& .MuiChip-labelSmall": {
			padding: 3,
			maxWidth: 85,
		},
		"& .MuiChip-deleteIconSmall": {
			marginRight: 2,
		},
	},
	chipStyleViewer: {
		...theme.typography.body1,
		display: "inline-flex",
		alignItems: "center",
		fontSize: theme.typography.fontSize,
		gap: 2,
		borderRadius: 3,
		"& .MuiChip-labelSmall": {
			padding: 3,
			maxWidth: 85,
		},
		marginRight: 3,
	},
	ownerTagStyle: {
		border: `1px solid ${theme.palette.tag.ownerBorder}`,
		background: `${theme.palette.tag.owner}`,
		"&:hover": {
			background: `${theme.palette.tag.ownerHover}`,
		},
		"&.MuiChip-deletable.MuiChip-outlined:focus": {
			background: `${theme.palette.tag.ownerHover}`,
		},
	},
	otherTagStyle: {
		border: `1px solid ${theme.palette.tag.otherBorder}`,
		background: `${theme.palette.tag.other}`,
		"&:hover": {
			background: `${theme.palette.tag.otherHover}`,
		},
		"&.MuiChip-deletable.MuiChip-outlined:focus": {
			background: `${theme.palette.tag.otherHover}`,
		},
	},
	chipIcon: {
		"& svg": {
			marginTop: "-10px",
		},
	},
}))

function TagChip({ tagData, getCurrContext, fileId, view }) {
	const classes = useStyles()
	const [anchorEl, setAnchorEl] = useState(null)
	const [menuData, setMenuData] = useState(null)

	const dispatch = useDispatch()

	const { tags } = useSelector((state) => state.tags.custom_tags)
	const { user } = useSelector((state) => state.authtentication.user)

	const getTagName = (tagId) => {
		const tag = tags?.find((item) => item.id === tagId)
		return tag?.name || null
	}

	const handleDelete = (e, tag) => {
		if (tag?.user_id === user?.userid) {
			handleRemoveTag(tag)
			//register tag is deleted
			localStorage.setItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH, true)
		} else {
			handleMenuTag(e, tag)
		}
	}

	const handleRemoveTag = (tagData) => {
		if (tagData?.tag_id) {
			const currContext = getCurrContext()
			dispatch(updateFileTag({ document_id: fileId, tag_id: tagData?.tag_id, context_id: currContext?.id, type: "remove" }))
		}
	}

	const handleMenuTag = (e, tagData) => {
		setAnchorEl(anchorEl ? null : e.currentTarget)
		setMenuData(tagData)
	}

	const handleClickAway = () => {
		anchorEl && setAnchorEl(null)
	}

	const slicedTagData = view === LIST_VIEW ? tagData?.slice(0, 2) : tagData
	const chipStyleClass = view === LIST_VIEW ? classes.chipStyle : classes.chipStyleViewer

	return (
		<>
			{slicedTagData?.map((item, index) => (
				<Chip
					key={item?.tag_id}
					aria-describedby={item?.tag_id}
					title={getTagName(item?.tag_id)?.length >= 11 ? getTagName(item?.tag_id) : false}
					size="small"
					label={getTagName(item?.tag_id)}
					variant="outlined"
					className={clsx(chipStyleClass, item?.user_id === user?.userid ? classes.ownerTagStyle : classes.otherTagStyle)}
					onDelete={(e) => handleDelete(e, item)}
					deleteIcon={
						item?.user_id === user?.userid ? (
							<Box component="span" className={classes.chipIcon}>
								<RemoveTagSVG />
							</Box>
						) : (
							<Box component="span" className={classes.chipIcon} onMouseLeave={handleClickAway}>
								<TagMenuSVG />
							</Box>
						)
					}
				/>
			))}
			{menuData && <TagMenuPoper menuData={menuData} anchorEl={anchorEl} handleClickAway={handleClickAway} />}
		</>
	)
}

export default TagChip
